import { useState } from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaWhatsapp,
  FaEnvelope,
  FaCheckCircle,
} from "react-icons/fa";
import PageHeader from "../components/layout/PageHeader";
import SectionTitle from "../components/common/SectionTitle";
import { PHONE_DISPLAY, WHATSAPP_DISPLAY, EMAIL, ADDRESS_LINE1, ADDRESS_LINE2 } from "../data/config";

const info = [
  { icon: <FaMapMarkerAlt />, title: "Our Location", lines: [ADDRESS_LINE1, ADDRESS_LINE2].filter(Boolean) },
  { icon: <FaPhoneAlt />, title: "Call Us", lines: [PHONE_DISPLAY, "24/7 Support Line"] },
  { icon: <FaWhatsapp />, title: "WhatsApp Us", lines: [WHATSAPP_DISPLAY, "Quick chat support"] },
  { icon: <FaEnvelope />, title: "Email Us", lines: [EMAIL, "Anytime support"] },
];

export default function Contact() {
  const [sent, setSent] = useState(false);
  return (
    <>
      <PageHeader title="Contact Us" crumbs={[{ label: "Contact" }]} />

      <section className="section">
        <div className="container">
          <div className="grid grid-4" style={{ marginBottom: 60 }}>
            {info.map((c, i) => (
              <div className="feature-box card" key={i}>
                <div className="fstrip-icon" style={{ margin: "0 auto 16px" }}>{c.icon}</div>
                <h3>{c.title}</h3>
                {c.lines.map((l, j) => (
                  <p key={j}>{l}</p>
                ))}
              </div>
            ))}
          </div>

          <div className="two-col">
            <div>
              <SectionTitle
                align="left"
                subtitle="Get In Touch"
                title="Have a Question? <span>Send Us a Message</span>"
                text="We'd love to hear from you. Fill out the form and our team will get back to you within 24 hours."
              />
              {sent ? (
                <div className="card" style={{ padding: 30, textAlign: "center" }}>
                  <div className="confirm-icon"><FaCheckCircle /></div>
                  <h3>Message Sent!</h3>
                  <p className="sec-text mt-2">Thanks for reaching out. We'll reply shortly.</p>
                </div>
              ) : (
                <form onSubmit={(e) => { e.preventDefault(); setSent(true); }}>
                  <div className="form-row">
                    <div className="field">
                      <label>Full Name</label>
                      <input type="text" placeholder="Your name" required />
                    </div>
                    <div className="field">
                      <label>Email</label>
                      <input type="email" placeholder="Your email" required />
                    </div>
                  </div>
                  <div className="field">
                    <label>Subject</label>
                    <input type="text" placeholder="Subject" required />
                  </div>
                  <div className="field">
                    <label>Message</label>
                    <textarea placeholder="Your message" required />
                  </div>
                  <button type="submit" className="btn btn-primary">Send Message</button>
                </form>
              )}
            </div>
            <div>
              <iframe
                title="Taxi 24hrs location"
                src="https://www.google.com/maps?q=148+Manor+Park+Road+London+NW10+4JR&output=embed"
                width="100%"
                height="520"
                style={{ border: 0, borderRadius: 16 }}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
